/**
 * B2B portal — progressive enhancement for the support form.
 *
 * The form is a native Shopify {% form 'contact' %} POST with browser
 * validation enabled, so it works with this file absent or blocked. This only
 * adds a double-submit guard, honeypot rejection and focus management.
 *
 * Custom elements re-run connectedCallback for every element the Theme Editor
 * injects, so section reloads need no extra wiring, and listeners are bound to
 * the component root only — never to document.
 *
 * No globals, no window pollution, no logging of customer or company data.
 */
(function () {
  "use strict";

  if (customElements.get("b2b-support-form")) return;

  class B2BSupportForm extends HTMLElement {
    connectedCallback() {
      if (this.dataset.b2bReady === "true") return;
      this.dataset.b2bReady = "true";

      this.form = this.querySelector("form");
      if (!this.form) return;

      this.submitButton = this.querySelector("[data-b2b-submit]");
      this.honeypot = this.querySelector('[name="contact[Fax]"]');

      this.onSubmit = this.handleSubmit.bind(this);
      this.form.addEventListener("submit", this.onSubmit);

      this.preselectTopic();
      this.focusStatus();
    }

    disconnectedCallback() {
      if (this.form && this.onSubmit) {
        this.form.removeEventListener("submit", this.onSubmit);
      }
      this.dataset.b2bReady = "false";
    }

    /**
     * Move focus to the success or error region after a server round-trip so
     * screen reader users are told the outcome without hunting for it.
     */
    focusStatus() {
      const status = this.querySelector("[data-b2b-status]");
      if (status) status.focus();
    }

    /**
     * ?topic=<value> (e.g. from the company page's "request a change" link)
     * preselects a topic, but only one that exists in the list.
     */
    preselectTopic() {
      const select = this.querySelector('[name="contact[Topic]"]');
      if (!select || select.value) return;
      let topic = "";
      try {
        topic = new URLSearchParams(window.location.search).get("topic") || "";
      } catch (e) {
        return;
      }
      const match = Array.prototype.find.call(select.options, (o) => o.value && o.value === topic);
      if (match) select.value = match.value;
    }

    handleSubmit(event) {
      if (this.honeypot && this.honeypot.value.trim() !== "") {
        event.preventDefault();
        return;
      }

      if (this.isSubmitting) {
        event.preventDefault();
        return;
      }

      if (!this.form.checkValidity()) return;

      this.isSubmitting = true;
      if (this.submitButton) {
        this.submitButton.setAttribute("aria-busy", "true");
        this.submitButton.disabled = true;
      }
    }
  }

  customElements.define("b2b-support-form", B2BSupportForm);
})();
